import React from 'react'
import App from './App.jsx'
import './index.css'
import { isHydratingPrerender } from './seo/prerenderState'
import { preloadRouteChunks } from './utils/lazyWithRetry'
import { takeOver } from './seo/takeOver'

// A prerendered public page (#2567) paints its own markup before this bundle
// arrives; hydrate it in place (#2605). Every other path (the app shell, or a
// prerendered file served for a different path) renders from scratch.
const root = document.getElementById('root')
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
// What is painted stays painted (#4474). The page's lazy chunks (named on
// #root by the build, and already downloading beside this bundle) load
// BEFORE React takes over the markup, so neither hydration nor a fresh render
// meets an unloaded chunk and shows the route spinner where the page was.
// Before this, a phone on slow 4G watched the college page turn into a
// spinner from ~4.0 s to ~6.8 s. Until they arrive the painted page stays
// as it is: readable, and its links work.
const routeChunks = (root.getAttribute('data-route-chunks') || '').split(' ').filter(Boolean)
// What the visitor typed or submitted meanwhile is given back once the app is
// listening (#5199, seo/takeOver.jsx).
preloadRouteChunks(routeChunks).then(() => {
  takeOver(root, app, {
    hydrate: isHydratingPrerender(),
    // A mismatch makes React re-render that part on the client: the page
    // still works, but log it so a drift between build and browser shows up.
    onRecoverableError: (error, info) => console.warn('[hydrate]', error && error.message, error && error.cause && error.cause.message, info && info.componentStack),
  })
})

// PWA: register the (minimal, no-precache) service worker in production only —
// registering in dev interferes with Vite HMR. It just enables home-screen
// install + a push hook; it never caches app assets, so it can't serve a stale
// build. Failures are swallowed — the app works fine without it.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* non-fatal */ })
  })
}
